<template>
  <v-layout class="payment-status">
    <v-icon size="16" class="status-icon status-colors" :class="statusColor">{{statusIcon}}</v-icon>
    <span :class="`status-text status-colors ${statusColor}`">{{statusH}}</span>
  </v-layout>
</template>

<script>
  export default {
    name: "PaymentStatus",
    props: {
      status: {
        type: String,
        required: true,
        validator: prop => ['outstanding', 'paid', 'overdue', 'pending', 'cancelled', 'refunded', 'invoiced', 'sent', 'approved', 'draft'].includes(prop.toLowerCase()),
      },
      statusH: {
        type: String,
        required: true
      }
    },
    computed: {
      statusColor() {
        if (this.colorClass) return this.colorClass
        switch (this.status) {
          case 'paid':
            return 'status-green'
          case 'pending':
            return 'status-outstanding'
          case 'outstanding':
            return 'status-outstanding'
          case 'due':
            return 'status-outstanding'
          case 'cancelled':
            return 'status-red'
          case 'hidden':
            return 'status-not_yet_due'
          case 'not yet due':
            return 'status-not_yet_due'
          case 'overdue':
            return 'status-overdue'
          case 'sent':
            return 'status-orange'
          default:
            return 'status-grey'
        }
      },
      statusIcon() {
        switch (this.status) {
          case 'paid':
            return 'icon-hand-cash'
          case 'cancelled':
            return 'icon-canceled'
          case 'approved':
            return 'icon-Completed'
          case 'sent':
            return 'icon-Sent1'
          case 'overdue':
            return 'icon-pending'
          case 'pending':
            return 'icon-Pending'
          case 'outstanding':
            return 'icon-Pending'
          case 'due':
            return 'icon-Pending'
          case 'invoiced':
            return 'icon-Invoiced'
          case 'hidden':
            return 'icon-expired'
          case 'not yet due':
            return 'icon-expired'
          case 'draft':
            return 'icon-pencil-new-medium'
          default:
            return ''
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
.payment-status {

  .status-icon {
    align-items: start;
  }

  .status-text {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    text-transform: uppercase;
    line-height: 1.5;
    letter-spacing: -0.2px;
    margin-left: 4px;
  }
}
</style>
